export default __webpack_public_path__ + "static/bt-color-99e64b55773828ed0f51411efe91130b.svg";